import React, { useState } from 'react';
import Text from 'antd/lib/typography/Text';
import {
  Form, Icon, Input, Button, Row, Checkbox, notification,
} from 'antd';
import { ViaLogo, LogoLocations } from '../../components/logo/ViaLogo';
import routeLocations from '../../utility/route-locations';
import { post } from '../../utility/via-fetch';


const formSummaryText = 'Thanks for your interest in Moblyx. If you would like to be notified of our launch please enter your details.';
const noEmailText = 'An email is required for notifying you on product launch.';
const invalidEmailText = 'The email you entered is invalid.';
const noNameText = 'A name is required.';
const invalidNameText = 'The name you have entered is invalid.';
const invalidOrganisationText = 'The organisation you have entered is invalid.';
const interestSelected = 'Please select a Moblyx product.';


const createEmailField = form => form.getFieldDecorator('email', {
  validateTrigger: 'onBlur',
  rules: [
    { required: true, message: noEmailText },
    { type: 'email', message: invalidEmailText },
  ],
})(
  <Input
    prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,0.25)' }} />}
    type="email"
    placeholder="Contact Email"
    maxLength={80}
  />,
);

const createNameField = form => form.getFieldDecorator('name', {
  rules: [
    { required: true, message: noNameText },
    { type: 'string', message: invalidNameText },
  ],
})(
  <Input
    prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,0.25)' }} />}
    type="text"
    placeholder="Contact Name"
    maxLength={80}
  />,
);

const createOrganisationField = form => form.getFieldDecorator('organisation', {
  rules: [
    { type: 'string', message: invalidOrganisationText },
  ],
})(
  <Input
    prefix={<Icon type="home" style={{ color: 'rgba(0,0,0,0.25)' }} />}
    type="text"
    placeholder="Organisation"
    maxLength={80}
  />,
);

const createAdditionalField = form => form.getFieldDecorator('additionalInformation', {
  rules: [
    { type: 'string', message: invalidOrganisationText },
  ],
})(
  <Input.TextArea
    rows={2}
    type="text"
    placeholder="Additional information"
  />,
);


/**
 * The form section of the Early Prospect page.
 */
const ProspectForm = Form.create({ name: 'prospect' })(({
  form,
}) => {
  const [authenticating, setAuthenticating] = useState(false);

  const submitForm = (e) => {
    e.preventDefault();

    form.validateFields((err, values) => {
      if (err) return;

      const prospects = values.prospects || [];

      const prospect = {
        email: values.email,
        name: values.name,
        organisation: values.organisation,
        additionalInformation: values.additionalInformation,
        inspectionProspect: prospects.includes('inspection'),
        carpoolProspect: prospects.includes('carpool'),
      };

      setAuthenticating(true);
      (async () => {
        try {
          await post('/api/early-prospect', undefined, prospect);
        } catch (serviceException) {
          console.log(serviceException);
        }
        setAuthenticating(false);

        // Even if it fails. Make it look like it went successfully. No prospect data is better than throwing errors to a prospect.
        notification.success({
          message: 'Thank you for your interest!',
          description: 'We will contact you soon regarding your interest in the Moblyx Apps.',
          duration: 10,
        });
        form.resetFields();
      })();
    });
  };

  return (
    <Form onSubmit={submitForm} className="app-login-form">
      <Form.Item>{createEmailField(form)}</Form.Item>
      <Form.Item>{createNameField(form)}</Form.Item>
      <Form.Item>{createOrganisationField(form)}</Form.Item>
      <Form.Item>
        {
          form.getFieldDecorator('prospects', {
            valuePropName: 'value',
            rules: [{ type: 'array', required: true, message: interestSelected }],
          })(<Checkbox.Group
            options={[
              { label: <>Notify me about <strong>M Inspect</strong></>, value: 'inspection' },
              { label: <>Notify me about <strong>M Carpool</strong></>, value: 'carpool' },
            ]}
          />)
        }
      </Form.Item>
      <Form.Item>{createAdditionalField(form)}</Form.Item>
      <Form.Item style={{ marginBottom: '0' }}>
        <Button
          type="primary"
          block
          htmlType="submit"
          loading={authenticating}
        >
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
});


export default function EarlyProspect() {
  return (
    <div className="app-registration-layout">
      <Row type="flex" align="middle" justify="center">
        <div className="app-registration-content">
          <Row type="flex" justify="center">
            <ViaLogo logoSrc={LogoLocations.MOBLYX_NORMAL_BLUE_CIRCLE_WHITE_M} href={routeLocations.landing} className="app-registration-logo" />
          </Row>
          <Row type="flex" justify="center">
            <Text className="registration-text">{formSummaryText}</Text>
          </Row>
          <Row>
            <ProspectForm />
          </Row>
        </div>
      </Row>
    </div>
  );
}
